import { render, staticRenderFns } from "./WelcomeCn.vue?vue&type=template&id=0d6b641c&scoped=true&"
import script from "./WelcomeCn.vue?vue&type=script&lang=js&"
export * from "./WelcomeCn.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeCn.vue?vue&type=style&index=0&id=0d6b641c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6b641c",
  null
  
)

export default component.exports